import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../../environments/environment";

import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";
@Component({
  selector: 'app-alumno-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent implements OnInit{
  tamano = document.body.clientHeight;
  API_PATH = environment.API_PATH;
  cargando = false;
  borrarCargando: boolean = false;
  permisos = JSON.parse(localStorage.getItem("permisos"));

  item;
  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(private http: HttpClient,private notificacion: NotificationsService,) { }
  ngOnInit() {
    
  }


  peticionReinicio(id: any): Observable<any> {
    let url = `${this.API_PATH}/api/v1/reset-password-docente/${id}`
    return this.http.get(url);
  }

  reiniciar(e,id){
    //console.log(id);
    this.item = id;
    document.getElementById("reiniciar-conteo").classList.add("is-active")
  }

  reincia_conteo(item){
    //console.log(item);
    this.cargando = true;

    let id = item;
    this.peticionReinicio(id).subscribe((resultado) =>{
      //console.log(resultado);
      this.cargando = false;
      this.borrarCargando = false;
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.texto = "Se reinicio la contraseña del docente";
      this.mensajeResponse.clase = "success";
      this.mensaje(2);
      this.cancelarFiltros("reiniciar-conteo");
    }, e =>{
      console.log(e);
      this.cargando = false;
      this.borrarCargando = false;
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.texto = "Ocurrio un error";
      this.mensajeResponse.clase = "danger";
      this.mensaje(2);
    })
  }

  cancelarFiltros(id) {
    document.getElementById(id).classList.remove("is-active");
    this.item = '';
  }

  mensaje(cuentaAtras: number = 6, posicion: any[] = ["middle", "center"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }
}

